import React, { useState, useEffect, useCallback } from "react";
import { useAuth } from "./AuthContext";
import { API_URL } from "../lib/utils";

const NotifContext = React.createContext(null);
export const useNotifications = () => React.useContext(NotifContext);

export const NotificationProvider = ({ children }) => {
    const { token, isAuthenticated, user } = useAuth();
    const [unreadCount, setUnreadCount] = useState(0);

    const fetchCount = useCallback(async () => {
        if (!token || !isAuthenticated || user?.role === "platform_owner") return;
        try {
            const res = await fetch(`${API_URL}/notifications/unread-count`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (res.ok) {
                const data = await res.json();
                setUnreadCount(data.count);
            }
        } catch {}
    }, [token, isAuthenticated, user?.role]);

    useEffect(() => {
        fetchCount();
        const interval = setInterval(fetchCount, 30000);
        return () => clearInterval(interval);
    }, [fetchCount]);

    return (
        <NotifContext.Provider value={{ unreadCount, refreshCount: fetchCount }}>
            {children}
        </NotifContext.Provider>
    );
};
